import React, {useState, useEffect} from 'react';
import {Card, Page, Layout, List, Button, Icon} from '@shopify/polaris';
import createApp from '@shopify/app-bridge';
import {Redirect} from '@shopify/app-bridge/actions';
import {getSessionToken} from "@shopify/app-bridge-utils";

function Subscription() {
    const [subscription, setSubscription] = useState(null);

    const [config, setConfig] = useState(null);

    useEffect(() => {
        fetchSubscription();
    }, []);

    const fetchSubscription = async () => {
        const query = new URLSearchParams(window.location.search);
        const configApp = {
            apiKey: window['apiKey'],
            host: query.get('host'),
            forceRedirect: true
        };
        setConfig(configApp);
        window['bridge-app'] = createApp(configApp);

        const sessionToken = await getSessionToken(window['bridge-app']);
        if (sessionToken) {
            const settings = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionToken
                }
            };

            const response = await fetch('https://contactautoreply.com/api/subscription/current/' + window.$queryString, settings);
            // if user session expired reload the page
            if (response.status === 403) {
                window.location.reload();
                return false;
            }
            // if shop is banned we just show an alert
            if (response.status === 404) {
                alert('Account disabled for suspicious activity!')
                return false;
            }
            const subscription = await response.json();
            setSubscription(subscription);

            if (subscription.subscription === 1 || subscription.subscription === 3) {
                let card = document.querySelector('.Polaris-Layout__Section:first-child .Polaris-Card');
                card.style.border = '2px solid #2FA822';
            } else {
                let card = document.querySelector('.Polaris-Layout__Section:last-child .Polaris-Card');
                card.style.border = '2px solid #2FA822';
            }
        }
    };

    const updateSubscription = async (subscriptionId) => {
        getSessionToken(window['bridge-app'])
            .then((sessionToken) => {
                const settings = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionToken
                    }
                };
                let apiUrl = '';
                switch(subscriptionId) {
                    case 1:
                        apiUrl = 'downgrade';
                        break;
                    case 2:
                        apiUrl = 'upgrade';
                        break;
                    case 3:
                        apiUrl = 'upgradebasicyearly';
                        break;
                    case 4:
                        apiUrl = 'upgradepremiumyearly';
                        break;
                    default:
                        apiUrl = 'downgrade';
                }

                fetch(`https://contactautoreply.com/api/subscription/${apiUrl}/${window.$queryString}`, settings)
                    .then(response => {
                        // if user session expired reload the page
                        if (response.status === 403) {
                            window.location.reload();
                            return false;
                        }

                        // if shop is banned we just show an alert
                        if (response.status === 404) {
                            alert('Account disabled for suspicious activity!')
                            return false;
                        }

                        return response.json();
                    }).then(response => {
                        const redirectUrl = response;
                        if (redirectUrl) {
                            const redirect = Redirect.create(window['bridge-app']);
                            redirect.dispatch(Redirect.Action.REMOTE, redirectUrl);
                        }
                    });
            })
            .catch((err) => console.log(err));
    };

    const upgradeSubscription = async () => {
        getSessionToken(window['bridge-app'])
            .then((sessionToken) => {
                const settings = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionToken
                    }
                };
                fetch(`https://contactautoreply.com/api/subscription/upgrade/${window.$queryString}`, settings)
                    .then(response => {
                        // if user session expired reload the page
                        if (response.status === 403) {
                            window.location.reload();
                            return false;
                        }

                        // if shop is banned we just show an alert
                        if (response.status === 404) {
                            alert('Account disabled for suspicious activity!')
                            return false;
                        }

                        return response.json();
                    }).then(response => {
                        const redirectUrl = response;
                        if (redirectUrl) {
                            const redirect = Redirect.create(window['bridge-app']);
                            redirect.dispatch(Redirect.Action.REMOTE, redirectUrl);
                        }
                    });
            })
            .catch((err) => console.log(err));
    };

    const downgradeSubscription = async () => {
        getSessionToken(window['bridge-app'])
            .then((sessionToken) => {
                const settings = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + sessionToken
                    }
                };
                fetch(`https://contactautoreply.com/api/subscription/downgrade/${window.$queryString}`, settings)
                    .then(response => {
                        // if user session expired reload the page
                        if (response.status === 403) {
                            window.location.reload();
                            return false;
                        }

                        // if shop is banned we just show an alert
                        if (response.status === 404) {
                            alert('Account disabled for suspicious activity!')
                            return false;
                        }

                        return response.json();
                    }).then(response => {
                        const redirectUrl = response;
                        if (redirectUrl) {
                            const redirect = Redirect.create(window['bridge-app']);
                            redirect.dispatch(Redirect.Action.REMOTE, redirectUrl);
                        }
                    });
            })
            .catch((err) => console.log(err));
    };

    return (
        <Page
            title="Manage Subscription Plan"
            breadcrumbs={[{content: 'Dashboard', url: `/${window.$queryString}`}]}
        >
            <Layout>
                <Layout.Section oneThird>
                    <Card title="Basic Plan" sectioned>
                        {
                            subscription && subscription.subscription === 1 ?
                                <div style={{fontWeight: 'bold', fontSize: '1.8rem'}}>
                                    $4 per Month - <span style={{color: '#2FA822'}}>Active</span>
                                </div>
                                :
                                <div style={{fontWeight: 'bold', fontSize: '1.8rem'}}>
                                    $4 per Month
                                </div>
                        }
                        <br/>
                        <List type="bullet">
                            <List.Item>Auto Reply Email for the Built-in Contact Form</List.Item>
                            <List.Item>Auto Reply Email for the Built-in Newsletter Form</List.Item>
                            <List.Item>Dynamic Email Message</List.Item>
                            <List.Item>Up to <b>1000</b> Emails per month</List.Item>
                            <List.Item>Support you in setting up your contact/newsletter form</List.Item>
                        </List>
                        {
                            subscription && subscription.subscription !== 1 ?
                                [
                                    <br/>,
                                    <Button onClick={() => {updateSubscription(1)}} primary>Change to Monthly Plan (4$/Month)</Button>
                                ]
                                :
                                null
                        }
                        <br/>
                        <hr/>
                        <br/>
                        {
                            subscription && subscription.subscription === 3 ?
                                <div style={{fontWeight: 'bold', fontSize: '1.8rem'}}>
                                    $40 per Year - <span style={{color: '#2FA822'}}>Active</span>
                                </div>
                                :
                                <div style={{fontWeight: 'bold', fontSize: '1.8rem'}}>
                                    $40 per Year
                                </div>
                        }
                        <br/>
                        <div style={{fontSize: '1.4rem'}}>
                            Same benefits as the Monthly Basic Plan
                        </div>
                        {
                            subscription && subscription.subscription !== 3 ?
                                [
                                    <br/>,
                                    <Button onClick={() => {updateSubscription(3)}} primary>Change to Yearly Plan (40$/Year)</Button>
                                ]
                                :
                                null
                        }
                    </Card>
                </Layout.Section>
                <Layout.Section oneThird>
                    <Card title="Premium Plan" sectioned>
                        {
                            subscription && subscription.subscription === 2 ?
                                <div style={{fontWeight: 'bold', fontSize: '1.8rem'}}>
                                    $8 per month - <span style={{color: '#2FA822'}}>Active</span>
                                </div>
                                :
                                <div style={{fontWeight: 'bold', fontSize: '1.8rem'}}>
                                    $8 per month
                                </div>
                        }
                        <br/>
                        <List type="bullet">
                            <List.Item>Auto Reply Email for the Built-in Contact Form</List.Item>
                            <List.Item>Auto Reply Email for the Built-in Newsletter Form</List.Item>
                            <List.Item>Dynamic Email Message</List.Item>
                            <List.Item>Up to <b>4000</b> Emails per month</List.Item>
                            <List.Item>Support you in setting up your contact/newsletter form</List.Item>
                        </List>
                        {
                            subscription && subscription.subscription !== 2 ?
                                [
                                    <br/>,
                                    <Button onClick={() => {updateSubscription(2)}} primary>Change to Monthly Plan (8$/Month)</Button>
                                ]
                                :
                                null
                        }
                        <br/>
                        <hr/>
                        <br/>
                        {
                            subscription && subscription.subscription === 4 ?
                                <div style={{fontWeight: 'bold', fontSize: '1.8rem'}}>
                                    $80 per Year - <span style={{color: '#2FA822'}}>Active</span>
                                </div>
                                :
                                <div style={{fontWeight: 'bold', fontSize: '1.8rem'}}>
                                    $80 per Year
                                </div>
                        }
                        <br/>
                        <div style={{fontSize: '1.4rem'}}>
                            Same benefits as the Monthly Premium Plan
                        </div>
                        {
                            subscription && subscription.subscription !== 4 ?
                                [
                                    <br/>,
                                    <Button onClick={() => {updateSubscription(4)}} primary>Change to Yearly Plan (80$/Year)</Button>
                                ]
                                :
                                null
                        }
                    </Card>
                </Layout.Section>
            </Layout>
        </Page>
    );
}

export default Subscription;
